import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import editorFormMixin from 'next/javascripts/mixins/editor-form-mixin';
import editorDraftMixin from 'next/javascripts/mixins/editor-draft-mixin';
import 'next/stylesheets/components/topic-form.scss';

Component('tr-topic-form', {
  mixins: [eventListenerMixin, editorFormMixin, editorDraftMixin],

  connected() {
    this.editor = this.querySelector('tr-editor');
    this.ccMembersWrapper = this.querySelector('.form-input-cc-members');
    this.focus();

    this.listenTo(this.querySelector('.cancel-button'), 'click', this.handleFormCancel.bind(this));
    this.listenTo(this, 'tao:change', this.handleInvisibleForVisitorChange.bind(this));

    if (this.ccMembersWrapper) {
      this.listenTo(this.ccMembersWrapper, {
        click: this.handleGroupClick.bind(this),
        'tr-checkbox-field:change': this.handleMemberChecked.bind(this),
      });
    }

    $(this).on('ajax:beforeSend', 'form', this.beforeFormSubmit.bind(this));
  },

  disconnected() {
    this.stopListening();
  },

  cancel() {
    this.remove();
  },

  focus() {
    const subjectInput = this.querySelector('.input-subject input');
    if (subjectInput) subjectInput.focus();
  },

  beforeFormSubmit(event, xhr, settings) {
    const attachIds = this.editor.getAttachIds();
    // eslint-disable-next-line no-param-reassign
    settings.data += `&attach_guids=${attachIds.join(',')}`;

    if (this.ccMembersWrapper) {
      const ccGuids = [
        ...this.ccMembersWrapper.querySelectorAll('.members tr-checkbox-field[checked]'),
      ].map(checkbox => checkbox.getValue());

      // eslint-disable-next-line no-param-reassign
      settings.data += `&cc_guids=${ccGuids.join(',')}`;
    }
  },

  handleFormCancel() {
    const cancel = this.namespacedTrigger('cancel');
    if (cancel) this.cancel();
  },

  handleInvisibleForVisitorChange(event) {
    if (!this.ccMembersWrapper) return;

    const checkbox = closest(
      event.target, '.form-input-invisible-for-visitor tr-checkbox-field',
    );
    if (!checkbox) return;

    const { checked } = checkbox;
    [...this.ccMembersWrapper.querySelectorAll('.members li[data-visitor]')]
      .forEach((member) => {
        member.classList.toggle('hide', checked);
      });
  },

  handleGroupClick(event) {
    const group = closest(event.target, '.groups .group');
    if (!group) return;

    group.classList.toggle('selected');
    this.toggleMemberCheckboxes();

    const groupId = group.dataset.group;
    if (groupId === '-1') {
      this.toggleAllGroupsSelected(group.classList.contains('selected'));
    } else {
      this.selectGroupAllIfNeeded();
    }
  },

  handleMemberChecked(event) {
    const checkbox = closest(event.target, '.members tr-checkbox-field');
    if (!checkbox) return;

    if (checkbox.checked) {
      this.selectGroupAllIfNeeded();
    } else {
      this.ccMembersWrapper
        .querySelector('.groups .group[data-group="-1"]')
        .classList.remove('selected');
    }
  },

  toggleMemberCheckboxes() {
    const selectedGroupIds = [
      ...this.ccMembersWrapper.querySelectorAll('.groups .group.selected'),
    ].map(group => group.dataset.group);

    [...this.ccMembersWrapper.querySelectorAll('.members tr-checkbox-field')]
      .forEach((checkbox) => {
        const memberGroups = JSON.parse(checkbox.dataset.groups);
        const selected = memberGroups
          .filter(groupId => selectedGroupIds.indexOf(groupId) !== -1).length > 0;
        // eslint-disable-next-line no-param-reassign
        checkbox.checked = selected;
      });
  },

  selectGroupAllIfNeeded() {
    const unselectedMembers = this.ccMembersWrapper
      .querySelectorAll('.members tr-checkbox-field:not([checked])');

    this.ccMembersWrapper
      .querySelector('.groups .group[data-group="-1"]')
      .classList.toggle('selected', unselectedMembers.length === 0);
  },

  toggleAllGroupsSelected(selected) {
    [...this.ccMembersWrapper
      .querySelectorAll('.groups .group:not([data-group="-1"])')]
      .forEach(group => group.classList.toggle('selected', selected));
  },
});
